import { useState, useEffect } from 'react'

const LATEST_VIDEO_ID = '4S2H-tJzHbg'

function VideoModal({ onClose }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [onClose])

  return (
    <div className="modal-overlay open" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="video-modal">
        <button className="video-modal-close" onClick={onClose}>✕</button>
        <div className="video-modal-embed">
          <iframe
            src={`https://www.youtube.com/embed/${LATEST_VIDEO_ID}?autoplay=1`}
            title="A2G Latest Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  )
}

export default function Hero({ t }) {
  const [playing, setPlaying] = useState(false)

  return (
    <>
      <div className="hero">
        <div className="hero-content">
          <div className="hero-badge">{t.hero_badge}</div>
          <h1>
            {t.hero_h1_1}<br />
            {t.hero_h1_2}<br />
            <em>{t.hero_h1_em}</em>
          </h1>
          <p className="hero-sub">
            {t.hero_sub}<br />
            <strong>{t.hero_sub_strong}</strong><br />
            {t.hero_sub2}
          </p>
          <div className="hero-actions">
            <a href="#subscribe" className="btn-primary">{t.hero_cta1}</a>
            <a href="#videos" className="btn-ghost" onClick={(e) => { e.preventDefault(); setPlaying(true) }}>
              <div className="play-icon">▶</div>
              <span>{t.hero_cta2}</span>
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div
            className="video-thumb"
            onClick={() => setPlaying(true)}
            style={{
              cursor: 'pointer',
              backgroundImage: `url(https://img.youtube.com/vi/${LATEST_VIDEO_ID}/maxresdefault.jpg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="video-thumb-overlay" />
            <div className="play-btn">▶</div>
            <div className="video-label">
              <div className="video-label-tag">📊 Market Report · 2026.03</div>
              <div className="video-label-title">{t.v1_title}</div>
            </div>
          </div>
          <div className="hero-visual-footer">
            <div className="sub-count">
              <div className="sub-avatars">
                <div className="sub-avatar">J</div>
                <div className="sub-avatar" style={{ background: 'linear-gradient(135deg,#f59e0b,#ef4444)' }}>A</div>
                <div className="sub-avatar" style={{ background: 'linear-gradient(135deg,#10b981,#3b82f6)' }}>M</div>
                <div className="sub-avatar" style={{ background: 'linear-gradient(135deg,#8b5cf6,#ec4899)' }}>+</div>
              </div>
              <div className="sub-text">
                <strong>1,240</strong>
                <span>{t.hero_subscribers}</span>
              </div>
            </div>
            <span className="new-badge">{t.hero_new_badge}</span>
          </div>
        </div>
      </div>

      {playing && <VideoModal onClose={() => setPlaying(false)} />}
    </>
  )
}
